import { useEffect } from "react";
import AboutThree from "../components/AboutThree";
import BannerThree from "../components/BannerThree";
// import BlogTwo from "../components/BlogTwo";
// import BrandTwo from "../components/BrandTwo";
// import ChooseUsTwo from "../components/ChooseUsTwo";
// import CounterTwo from "../components/CounterTwo";
// import EventOne from "../components/EventOne";
// import FacultyOne from "../components/FacultyOne";
import FooterThree from "../components/FooterThree";
import HeaderOne from "../components/HeaderOne";
import InfoTwo from "../components/InfoTwo";
// import TestimonialsThree from "../components/TestimonialsThree";
import VideoOne from "../components/VideoOne";
import Animation from "../helper/Animation";
import Preloader from "../helper/Preloader";
// import {
//   fetchHomeCount,
// } from "../api/HomeApi";
import { useLoader } from "../context/LoaderContext";
import { useSchoolDetailsContext } from "../context/SchoolDetailsContext";
import { fetchSchoolDetails } from "../api/SchoolDetailsApi";
import { useAllDataContext } from "../context/AllDataContext";
import { FetchAllApi } from "../components/FetchAllApi";
import { useLocation } from "react-router-dom";
import ChairmenMessage from "../components/ChairmenMessage";
import ChooseUsOne from "../components/ChooseUsOne";

const HomePageThree = () => {
  const { setLoading } = useLoader();
  const { schoolDetailsData, setSchoolDetailsData } = useSchoolDetailsContext();
  const { allData, setAllData } = useAllDataContext();
  const location = useLocation();

  const section = location.state?.section;

  useEffect(() => {
    if (section) {
      const el = document.getElementById(section.toLowerCase());
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [section]);

  // const [sliderData, setSliderData] = useState([]);
  // const [tilesData, setTilesData] = useState([]);
  // const [aboutData, setAboutData] = useState([]);
  // const [highlightsData, setHighlightsData] = useState([]);
  // const [countData, setCountData] = useState([]);
  // const [testimonialHeaderData, setTestimonialHeaderData] = useState([]);
  // const [testimoniaData, setTestimoniaData] = useState([]);

  const sliderData = allData.sliderData;
  const tilesData = allData.tilesData;
  const aboutData = allData.aboutData;
  const highlightsData = allData.highlightsData;
  const chairmanData = allData.chairmenData;
  const chooseUsData = allData.chooseUsData;
  const tilesHeaderData = allData.tilesHeaderData;
  // const testimonialHeaderData = allData.testimonialHeaderData;
  // const testimoniaData = allData.testimoniaData;

  // useEffect(() => {
  //   Promise.all([fetchHomeCount()])
  //     .then(([homeCountData]) => {
  //       setCountData(homeCountData);
  //     })
  //     .catch(() => {
  //       console.error("Server Error");
  //     });
  // }, []);

  FetchAllApi({ schoolDetailsData, setAllData, setLoading });

  // useEffect(() => {
  //   setLoading(true);
  //   if (schoolDetailsData.length === 0) {
  //     Promise.all([
  //       fetchHomeSliders(),
  //       fetchHomeTiles(),
  //       fetchHomeAbout(),
  //       fetchHomeHighlights(),
  //       // fetchHomeCount(),
  //       fetchHomeTestimonialHeader(),
  //       fetchHomeTestimonial(),
  //     ])
  //       .then(
  //         ([
  //           homeSliderData,
  //           homeTilesData,
  //           homeAboutData,
  //           homeHighlightsData,
  //           // homeCountData,
  //           homeTestimonialHeaderData,
  //           homeTestimonialData,
  //         ]) => {
  //           setSliderData(homeSliderData);
  //           setTilesData(homeTilesData);
  //           setAboutData(homeAboutData);
  //           setHighlightsData(homeHighlightsData);
  //           // setCountData(homeCountData);
  //           setTestimonialHeaderData(homeTestimonialHeaderData);
  //           setTestimoniaData(homeTestimonialData);
  //           setTimeout(() => {
  //             setLoading(false);
  //           }, 500);
  //         }
  //       )
  //       .catch(() => {
  //         console.error("Server Error");
  //         setTimeout(() => {
  //           setLoading(false);
  //         }, 500);
  //       });
  //   } else {
  //     setTimeout(() => {
  //       setLoading(false);
  //     }, 500);
  //   }
  // }, [schoolDetailsData.length, setAllData, setLoading]);
  useEffect(() => {
    if (schoolDetailsData.length === 0) {
      Promise.all([fetchSchoolDetails()])
        .then(([schoolDetailsData]) => {
          setSchoolDetailsData(schoolDetailsData);
        })
        .catch(() => {
          console.error("Server Error");
        });
    }
  }, [schoolDetailsData.length, setSchoolDetailsData]);

  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* HeaderOne */}
      <HeaderOne />

      {/* Animation */}
      <Animation />

      {/* BannerThree */}
      <BannerThree sliderData={sliderData} />

      {/* InfoTwo */}
      <InfoTwo tilesHeaderData={tilesHeaderData} tilesData={tilesData} />

      {/* AboutThree */}
      <AboutThree aboutData={aboutData} />

      <ChairmenMessage chairmanData={chairmanData}/>

      <ChooseUsOne chooseUsData={chooseUsData}/>

      {/* VideoOne */}
      <VideoOne highlightsData={highlightsData} />

      {/* CounterTwo */}
      {/* <CounterTwo countData={countData} /> */}

      {/* FacultyOne */}
      {/* <FacultyOne facultyHeaderData={facultyHeaderData} facultyListData={facultyListData}/> */}

      {/* ChooseUsTwo */}
      {/* <ChooseUsTwo /> */}

      {/* TestimonialsThree */}
      {/* <TestimonialsThree
        testimonialHeaderData={testimonialHeaderData}
        testimoniaData={testimoniaData}
      /> */}

      {/* EventOne */}
      {/* <EventOne /> */}

      {/* BlogTwo */}
      {/* <BlogTwo /> */}

      {/* BrandTwo */}
      {/* <BrandTwo /> */}

      {/* FooterThree */}
      <FooterThree />
    </>
  );
};

export default HomePageThree;
